import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import theme from '../../../theme';

//import { grey } from '@material-ui/core/colors';

import {Button} from '@material-ui/core';
import {Grid, Container, Box} from '@material-ui/core';

//import {Tab, Tabs} from '@material-ui/core';
//import {TabPanel} from '../../../components/TabPanel'

//import {ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails} from '@material-ui/core';
//import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import {ApplicationBar} from '../../../components/ApplicationBar';

//import Logo from '../../components/Logo';

//import {TabbedMenu} from './TabbedMenu';

import {Dialog} from '../../../components/Dialog';

//import {getBase64ID, getIndexByID} from '../../../api/helpers'; //, getIndexByID, base64toGuid, sortByName
import { LicensesList } from './LicensesList';

//import { Label } from '@material-ui/icons';


class LicensesEditor_ extends React.Component {
    
    constructor(props){
        super(props);

        this.state = {
            licenses: []// this.props.licenses
        }

        this.handleAction = this.handleAction.bind(this)
    }

    componentDidMount(){
        //console.log('componentDidMount')
        this.props.onAction({type: 'GET_LICENSES', callback: this.onGetLicenses.bind(this) })
    }
    componentDidUpdate(){

    }

    onGetLicenses(licenses){
        //console.log('onGetLicenses')
        //console.log(licenses)
        this.setState({licenses: licenses})
    }


    handleDispatcherSelect(dispatcherID){
        this.setState({currentDispatcherID: dispatcherID})
    }

    handleExternalNetworkSelect(externalNetworkID){
        this.setState({currentExternalNetworkID: externalNetworkID})
    }

    getNetwork(networkID){
        for(let i=0; i<this.props.networks.length; i++){
            if(this.props.networks[i].ID === networkID) return this.props.networks[i];
        }
        return null
    }
    

    handleTabClick(tab){
        this.setState({selectedTab: tab});
    }

    handleButtonSave(){
        this.props.onAction({type:'LICENSES_EDITOR_SAVE', serverSettings: this.state.licenses})
    }

    handleButtonCancel(){
        this.props.onAction({type:'LICENSES_EDITOR_CLOSE'})
    }


    
    handleAction(action){
        console.log('Licenses handleAction')
        console.log(action)
        this.props.onAction(action)
    }


    


    render(){
        const {t} = this.props

        let list = "LICENSES"
        let statusMessage = ""
           
        return (
            <Grid item xs={12} style={{height:'100vh'}}>

                <ApplicationBar user={this.props.user}
                    onAction={this.handleAction}>
                    {/*network ? network.Name : ''*/}
                </ApplicationBar>

                <Grid container key="1" justify="flex-start" spacing={0} style={{height:'83%', borderTop:'1px solid '+theme.palette.border.dialog}} >
                    <Grid xs={12} item style={{}}>
                        <Container height="100vh" style={{padding:0, paddingTop: '1em'}}>

                            <Dialog width="xl" variant="h6" align="left" title={t('Licenses')} style={{}}>

                                <Box textAlign="left" style={{paddingBottom: '1em'}}>


                                    <LicensesList licenses={this.state.licenses}></LicensesList>


                                </Box>
                                <Box textAlign="center" style={{}}>
                                    {/** 
                                    <Button variant="contained" color="primary" 
                                        onClick={this.handleButtonSave.bind(this)} 
                                        style={{margin: '0 0.4em'}}>{t('Apply')}</Button>
                                    <Button variant="contained" color="inherit"
                                        onClick={this.handleButtonCancel.bind(this)} 
                                        style={{margin: '0 0.4em'}} >{t('Cancel')}</Button>
                                    */}
                                    <Button variant="contained" color="inherit"
                                        onClick={this.handleButtonCancel.bind(this)} 
                                        style={{margin: '0 0.4em'}} >{t('Close')}</Button>
                                </Box>
                            </Dialog>

                        </Container>
                    </Grid>
                </Grid>
                <Grid xs={12} key="2" item style={{height:'3em'}}>
                    {statusMessage}{/*Server Status*/}
                </Grid>
            </Grid>
        );
    }
}

export const LicensesEditor = withTranslation()(LicensesEditor_);